import { ErrorStateContentBox } from 'components/ErrorStates/ErrorStateContentBox/ErrorStateContentBox';

export const NoSitesErrorState = () => {
  return (
    <ErrorStateContentBox
      headingText={'No data to show'}
      subText={
        <>
          <div>This company does not contain any sites.</div>
          <div>Please select another company.</div>
        </>
      }
    />
  );
};
